import { render } from "./ChannelTableItem.vue?vue&type=template&id=1e7ef3a8"
import script from "./ChannelTableItem.vue?vue&type=script&lang=js"
export * from "./ChannelTableItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__